// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"487":"dc18a0f5","990":"4e9372b2"}[chunkId] + ".chunk.js";
};